import { useMemo } from 'react';

import { useGetAllProposals } from 'api/projectVersioning/hooks/useGetAllProposals';
import type { Proposal, ProposalStatus } from 'api/projectVersioning/types';

const ACTIVE_STATUSES: ProposalStatus[] = ['Draft', 'Published'];
const HISTORY_STATUSES: ProposalStatus[] = ['Merged', 'Discarded'];

const byLastUpdatedDesc = (a: Proposal, b: Proposal) =>
  new Date(b.updated ?? b.created).getTime() - new Date(a.updated ?? a.created).getTime();

export const useAllProposalsData = () => {
  const { data: proposals = [], isLoading, isError } = useGetAllProposals([...ACTIVE_STATUSES, ...HISTORY_STATUSES]);

  const activeProposals = useMemo(
    () => proposals.filter((proposal) => ACTIVE_STATUSES.includes(proposal.status)).sort(byLastUpdatedDesc),
    [proposals]
  );

  const historyProposals = useMemo(
    () => proposals.filter((proposal) => HISTORY_STATUSES.includes(proposal.status)).sort(byLastUpdatedDesc),
    [proposals]
  );

  return {
    activeProposals,
    historyProposals,
    isActiveProposalsLoading: isLoading,
    isHistoryProposalsLoading: isLoading,
    isActiveProposalsError: isError,
    isHistoryProposalsError: isError
  };
};
